import { render, staticRenderFns } from "./SetPromotionAdd.vue?vue&type=template&id=03aaa7d4&scoped=true"
import script from "./SetPromotionAdd.vue?vue&type=script&lang=js"
export * from "./SetPromotionAdd.vue?vue&type=script&lang=js"
import style0 from "./SetPromotionAdd.vue?vue&type=style&index=0&id=03aaa7d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aaa7d4",
  null
  
)

export default component.exports